import { Theme } from '@fluentui/theme';
import * as React from 'react';

export const ThemeContext = React.createContext<Theme | undefined>(undefined);
